const faqs = [
  {
    question: "Does Massachusetts have its own passport agency?",
    answer: "Massachusetts does not have a traditional in-person regional passport agency for walk-in emergency appointments. The Boston National Passport Center at 10 Causeway St in Boston processes applications by mail. For emergency in-person appointments (travel within 3 days or life-or-death emergencies), Massachusetts residents typically travel to the New York Passport Agency. Most MA travelers find that using an approved courier like Fast Passport Center is significantly faster.",
  },
  {
    question: "How fast can I get a passport in Massachusetts?",
    answer: "With Fast Passport Center's courier service, Massachusetts travelers can receive a passport in as little as 24 hours for true emergencies. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Greater Boston residents have more acceptance facility options, making in-person applications faster.",
  },
  {
    question: "Do I need to visit an acceptance facility in Massachusetts?",
    answer: "First-time applicants, minors under 16, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, town clerk, or city clerk). Massachusetts has hundreds of acceptance facilities across the state. Renewals for adults with a passport issued within the last 15 years can usually be done by mail.",
  },
  {
    question: "Which Massachusetts airport should I fly from?",
    answer: "Logan International (BOS) in Boston is Massachusetts's major international airport with direct flights to Europe, Asia, and the Americas. For Western MA residents, Bradley International (BDL) in Hartford, CT is often closer. Providence's T.F. Green (PVD) serves Southern MA and Rhode Island. Worcester Regional (ORH) serves Central MA with connecting flights.",
  },
  {
    question: "Can I renew my passport by mail in Massachusetts?",
    answer: "Yes — if your most recent passport was issued when you were 16 or older, within the last 15 years, is undamaged, and in your current name, you can renew by mail using Form DS-82. Mail to the National Passport Processing Center. For faster service, Fast Passport Center offers 2-3 week expedited renewal.",
  },
  {
    question: "Do I need a passport for a Massachusetts ferry to Martha's Vineyard or Nantucket?",
    answer: "No — Martha's Vineyard and Nantucket are U.S. territories, so you do not need a passport for the ferry from Hyannis, Woods Hole, or New Bedford. However, if you're taking a cruise that stops at international ports, a valid passport is required. Always check with your carrier for specific requirements.",
  },
];

export { faqs };

export default function MassachusettsFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Massachusetts Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the Bay State.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}